import { render, staticRenderFns } from "./OrganisationsPage.vue?vue&type=template&id=60418933&scoped=true&"
import script from "./OrganisationsPage.vue?vue&type=script&lang=js&"
export * from "./OrganisationsPage.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationsPage.vue?vue&type=style&index=0&id=60418933&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60418933",
  null
  
)

export default component.exports